/* ==========================================================
   FLAGS — each `img` is a FULL Shopify Files URL (used as-is).
========================================================== */
const FLAG_BASE = 'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/';

/* ==========================================================
   COUNTRY RULE MAP
   region:'eu'   -> front white / rear yellow (different)
   region:'asia' -> both white (same on front & rear)
   For the "Asian = same" behaviour, add a country with region:'asia'.
========================================================== */
const COUNTRIES = [
  {code:'GB',  name:'GB',  img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/gb_small_589e4aa9-b1ce-4dfa-b43b-731b0e2cfbda.png?v=1781560272',  region:'eu'},
  {code:'SCO', name:'SCO', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/sco_small_3279e288-ac8e-4995-af1b-e1cc0874cf0d.png?v=1781560272', region:'eu'},
  {code:'CYM', name:'CYM', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/cym_small_6ff2b627-ceed-432a-9e7f-81c3ad95f45b.webp?v=1781560681', region:'eu'},
  {code:'NI',  name:'NI',  img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/ni_small_da16d280-969c-4cb9-94c1-d04b2f9b4efc.png?v=1781560681',  region:'eu'},
  {code:'GER', name:'GER', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/ger_small_0752ed69-edb4-411e-9837-5b425c25af6b.png?v=1781560681', region:'eu'},
  {code:'ESP', name:'ESP', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/esp_small_8276c6e9-9771-4041-a8ac-fb9cab25bac2.png?v=1781560681', region:'eu'},
  {code:'FRA', name:'FRA', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/fra_small_ac092fd1-9ca1-41c8-84bf-e9aea658d005.png?v=1781560681', region:'eu'},
  {code:'ITA', name:'ITA', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/ita_small_80d2093c-842e-4220-89bc-5969ba9f1839.png?v=1781560680', region:'eu'},
  {code:'NLD', name:'NLD', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/nld_small_fce182c6-753c-426e-910a-e13a692ff769.png?v=1781560272', region:'eu'},
  {code:'ENG', name:'ENG', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/eng_small_d8b70aae-3042-4ba2-a09d-722ab25162cb.png?v=1781562677', region:'eu'},
  {code:'POL', name:'POL', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/pol_small_9f8e864b-f67e-4c98-8567-66e288a63e47.png?v=1781562803', region:'eu'},
  {code:'ROU', name:'ROU', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/rou_small_1523c060-83d0-42d0-a9af-bcb31b44f872.png?v=1781562907', region:'eu'},
  {code:'ALB', name:'ALB', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/alb_small_faa70071-5e40-43b0-b0f4-ea63c90aa1e1.png?v=1781563015', region:'eu'},
  {code:'CYP', name:'CYP', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/cyp_small_8586a78f-9772-43c8-955c-a41c42c4bdc9.png?v=1781563127', region:'eu'},
  {code:'PRT', name:'PRT', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/prt_small_fa226023-20d1-4df4-aed5-967e2700d443.png?v=1781563229', region:'eu'},
  {code:'EUR', name:'EUR', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/eur_small_61141155-352f-42b7-ba24-9f64cf90c498.png?v=1781563330', region:'eu'},
  {code:'IRL', name:'IRL', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/irl_small_15f3d292-7c5f-41f8-b8f1-95257a53b29d.png?v=1781560681', region:'eu'},
   {code:'BGD', name:'BGD', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/bgd_small_3cf98a60-d2f4-45be-a5b8-9bab9eec993a.png?v=1781563779', region:'asia'},
  {code:'TUR', name:'TUR', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/tur_small_37876483-4e74-44d5-afd0-34550e1f1270.png?v=1781563859', region:'asia'}, 
  {code:'TTO', name:'TTO', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/tto_small_f6984b74-9184-41fa-a332-c6edcffe18dc.png?v=1781564050', region:'asia'}, 
  {code:'SWE', name:'SWE', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/swe_small_e73d392a-d423-494f-b237-07704cc77488.png?v=1781564169', region:'asia'}, 
   {code:'RUS', name:'RUS', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/rus_small_010d935d-7aed-4c3a-8dbe-67e57ae83772.png?v=1781564291', region:'asia'}, 
   {code:'PAK', name:'PAK', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/pak_small_a443066c-43d9-4468-9b6a-35c714487f64.png?v=1781564343', region:'asia'}, 
   {code:'NOR', name:'NOR', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/nor_small_152c542e-6457-4130-b4ea-e331433799e9.png?v=1781564627', region:'asia'}, 
   {code:'LTU', name:'LTU', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/ltu_small_cffdef06-ab34-4b17-9195-1d933d158f6d.png?v=1781564713', region:'asia'}, 
   {code:'LVA', name:'LVA', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/lva_small_e65b1a74-a7a4-453d-8399-aa2a4a0a7c40.png?v=1781564871', region:'asia'}, 
   {code:'JAM', name:'JAM', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/jam_small_c5839e57-41ee-43e7-a431-d0ec66f6d212.png?v=1781564999', region:'asia'}, 
   {code:'IND', name:'IND', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/ind_small_805df3f2-cf3e-4bde-aff3-d0f37f7392b0.png?v=1781565091', region:'asia'}, 
   {code:'HUN', name:'HUN', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/hun_small_85a52e23-a58f-4b42-90a3-efd672f0c2a0.png?v=1781565173', region:'asia'}, 
   {code:'FIN', name:'FIN', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/fin_small_1c62b1a1-97ed-4296-8335-b18a12968193.png?v=1781565232', region:'asia'}, 
   {code:'EST', name:'EST', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/est_small_e2fba51e-b047-489d-a1ce-7215edcfca92.png?v=1781565317', region:'asia'}, 
   {code:'DNK', name:'DNK', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/dnk_small_c78830e3-660f-42bf-8770-7a4509e43ddf.png?v=1781565377', region:'asia'}, 
   {code:'BGR', name:'BGR', img:'https://cdn.shopify.com/s/files/1/0995/1559/7126/files/bgr_small_7fb09c19-c859-4b1f-856d-a0f0c4881a23.png?v=1781565550', region:'asia'}, 

];

const RULES = {
  eu:   {front:'white', rear:'yellow'},
  asia: {front:'white', rear:'white'},
};

(function(){
  function flagURL(c){
    return /^https?:\/\//.test(c.img) ? c.img : FLAG_BASE + c.img;
  }

  var state = {country: COUNTRIES[0], name: ''};
  var $ = function(id){ return document.getElementById(id); };

  function currentProps(){
    var rule = RULES[state.country.region];
    return {
      'Plate text': state.name || 'ANY NAME',
      'Country': state.country.code,
      'Front plate': rule.front,
      'Rear plate': rule.rear
    };
  }

  function buildGrid(){
    var g = $('pc-grid');
    if(!g) return;
    COUNTRIES.forEach(function(c){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pc-flag-btn' + (c.code===state.country.code ? ' pc-active' : '');
      b.innerHTML = '<span class="pc-circle"><img src="' + flagURL(c) + '" alt="' + c.name + '"></span>'
                  + '<span class="pc-name">' + c.name + '</span>';
      b.onclick = function(){ state.country = c; render(); };
      g.appendChild(b);
    });
  }

  function getCart(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  }

  // map of cart line key -> quantity, used to spot what changed
  function qtyMap(cart){
    var m = {};
    (cart.items || []).forEach(function(it){ m[it.key] = it.quantity; });
    return m;
  }

  function applyProps(lineKey, props){
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: lineKey, properties: props })
    }).then(function(){ document.dispatchEvent(new CustomEvent('plate:updated')); });
  }

  /* On add-to-cart: snapshot cart, then poll for the line that is NEW
     or whose quantity increased, and patch THAT line. This avoids the
     "5 forms on the page" problem entirely — we don't need the form. */
  function hookAddToCart(){
    document.addEventListener('click', function(e){
      var t = e.target;
      if(!t || !t.closest) return;
      var btn = t.closest('[name="add"], [type="submit"], .add-to-cart, .product-form__submit, .btn-addtocart, .product-form button, button[type="submit"]');
      if(!btn) return;

      var props = currentProps(); // capture the CURRENT selection at click time

      getCart().then(function(before){
        var beforeQty = qtyMap(before);
        var attempts = 0;
        var timer = setInterval(function(){
          attempts++;
          getCart().then(function(after){
            var changedKey = null;
            (after.items || []).forEach(function(it){
              var prev = beforeQty[it.key] || 0;
              if(it.quantity > prev) changedKey = it.key; // new or increased line
            });
            if(changedKey){
              clearInterval(timer);
              applyProps(changedKey, props);
            } else if(attempts > 12){
              clearInterval(timer);
            }
          }).catch(function(){ if(attempts > 12) clearInterval(timer); });
        }, 400);
      });
    }, true);
  }

  function render(){
    if(!$('pc-frontPlate')) return;
    var name = state.name || 'ANY NAME';
    var rule = RULES[state.country.region];

    $('pc-frontPlate').className = 'pc-plate pc-' + rule.front;
    $('pc-rearPlate').className  = 'pc-plate pc-' + rule.rear;
    $('pc-fText').textContent = name;
    $('pc-rText').textContent = name;

    var url = flagURL(state.country);
    ['f','r'].forEach(function(p){
      $('pc-' + p + 'Flag').src = url;
      $('pc-' + p + 'Flag').alt = state.country.name;
      $('pc-' + p + 'Code').textContent = state.country.code;
    });

    var btns = document.querySelectorAll('#pc-grid .pc-flag-btn');
    btns.forEach(function(b,i){ b.classList.toggle('pc-active', COUNTRIES[i].code===state.country.code); });

    $('pc-note').innerHTML = state.country.region==='eu'
      ? '<b>' + state.country.code + '</b> is European \u2192 front and rear are different.'
      : '<b>' + state.country.code + '</b> is Asian \u2192 front and rear are identical.';

    $('pc-cnt').textContent = state.name.length;
  }

  function init(){
    var root = $('pc-root');
    if(!root) return;

    var toggle = $('pc-toggle');
    if(toggle){
      toggle.addEventListener('click', function(){
        var collapsed = root.classList.toggle('pc-collapsed');
        toggle.setAttribute('aria-expanded', String(!collapsed));
      });
    }

    var reg = $('pc-reg');
    if(reg){
      reg.addEventListener('input', function(e){
        state.name = e.target.value.toUpperCase();
        e.target.value = state.name;
        render();
      });
    }

    buildGrid();
    render();
    hookAddToCart();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
